module.exports = __webpack_public_path__ + "static/img/btn-gz.d56ec2ba.png";